import React, { ReactElement, useEffect } from 'react';
import useCreateDashboard from 'adapter/in/dashboards/hooks/Dashboard/useCreateDashboard';
import DashboardNameModal, { DashboardNameFormData } from 'adapter/in/dashboards/pages/Modals/DashboardNameModal';
import { useForm } from 'react-hook-form';
import i18n from 'asset/translation';

export type CreateDashboardModalContainerProps = {
    showModal: boolean;
    setShowModal: (show: boolean) => void;
};

const CreateDashboardModalContainer = (props: CreateDashboardModalContainerProps): ReactElement => {
    const { showModal, setShowModal } = props;
    const { create, success, error, isLoading } = useCreateDashboard();
    const { handleSubmit, reset: formReset, control } = useForm<DashboardNameFormData>();

    useEffect(() => {
        if (showModal) {
            formReset();
        }
    }, [showModal]);

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const onInternalSubmit = (data: DashboardNameFormData) => {
        create(data.name);
    };

    const handleFormSubmit = () => {
        handleSubmit(onInternalSubmit)();
    };

    return (
        <DashboardNameModal
            title={i18n.t('dashboards.create.modalTitle')}
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            success={success}
            isLoading={isLoading}
            error={error}
            control={control}
            handleOnSubmit={handleFormSubmit}
        />
    );
};

export default CreateDashboardModalContainer;
